import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBTEuFFKhssq2TPUqfXrm5bfOAKIxAewDY",
    authDomain: "stamp-medical.firebaseapp.com",
    projectId: "stamp-medical",
    storageBucket: "stamp-medical.firebasestorage.app",
    messagingSenderId: "101801963927",
    appId: "1:101801963927:web:794ec65240dcf303bd94d2",
    measurementId: "G-TGHM3JVLXR",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Connect to emulators when running locally
const useEmulators = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

if (useEmulators && !window._emulatorsConnected) {
    connectFirestoreEmulator(db, "localhost", 8085);
    connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
    connectStorageEmulator(storage, "localhost", 9199);
    connectFunctionsEmulator(functions, "localhost", 5001);
    window._emulatorsConnected = true;
    console.log("🔧 Connected to Firebase emulators");
}

export default app;
